import { CodedError } from '../../CodedError';
import { errorCodes } from '../../constants/errorCodes';

export class PaymentNotSetupError extends CodedError {
  static get errorName() {
    return errorCodes.paymentNotSetupError.code;
  }

  constructor(message: string = errorCodes.paymentNotSetupError.message) {
    super(message);
    this.code = errorCodes.paymentNotSetupError.code;
    this.message = `${message} ${errorCodes.paymentNotSetupError.code}`;
    this.name = errorCodes.paymentNotSetupError.name;
  }
}
